import React from "react";
import ContactForm from "@/components/ContactForm";
import useSEO from "@/lib/seo";

export default function Kontakt() {
  useSEO({
    title: "Kontakt",
    description: "Fragen, Anregungen oder Hinweise zum Quartier am Hornschen Tor in Detmold — schreiben Sie der Stadt Detmold direkt über das Kontaktformular.",
    path: "/kontakt",
  });
  return (
    <div className="container-narrow py-16 lg:py-24 max-w-3xl" data-testid="kontakt-page">
      <p className="text-xs uppercase tracking-[0.18em] text-[hsl(var(--brand-green-strong))] mb-4">Kontakt</p>
      <h1 className="font-semibold text-4xl sm:text-5xl mb-6">Ihr Anliegen an die Stadt</h1>
      <p className="text-neutral-600 mb-12 leading-relaxed">
        Haben Sie Fragen, Anregungen oder Hinweise zum Quartier am Hornschen Tor? Nutzen Sie das untenstehende Formular — Ihr Anliegen wird direkt an die zuständige Stelle der Stadt Detmold weitergeleitet.
      </p>
      <ContactForm compact />
    </div>
  );
}
